import { useEffect, useState } from "react";
import { companyRequest } from "@/services/companyRequest";

// Retain data only while refreshing the same view and authorization scope.
// Another facility, filter or session must never display a previous response.
export function useActivitySection({ endpoint, scope, params, revision, enabled }) {
  const serializedParams = JSON.stringify(params);
  const key = JSON.stringify([endpoint, scope, serializedParams]);
  const [state, setState] = useState({});
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    const controller = new AbortController();
    setState(previous => ({ key, revision, loading: true, data: previous.key === key ? previous.data : null }));
    companyRequest.get(endpoint, { params: JSON.parse(serializedParams), signal: controller.signal, timeout: 30000 })
      .then(response => {
        const data = response?.data ?? response;
        if (!data?.window || !data?.coverage) throw new Error("Activity response is unavailable");
        if (active) setState({ key, revision, data, loading: false });
      })
      .catch(error => {
        if (!active) return;
        const denied = [401, 403].includes(error.response?.status);
        setState(previous => ({ key, revision, loading: false, data: denied ? null : previous.data,
          error: denied ? "You do not have access to this activity view." : "This section could not be loaded. Please retry." }));
      });
    return () => { active = false; controller.abort(); };
  }, [endpoint, key, serializedParams, revision, enabled]);
  const matches = enabled && state.key === key;
  return { data: matches ? state.data : null, error: matches ? state.error : null,
    loading: enabled && (!matches || state.revision !== revision || state.loading) };
}
